import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { AxiosError } from 'axios';
import { useSnackbar } from 'notistack';
import {
  Box,
  IconButton,
  Typography,
} from '@mui/material';
import { ArrowBackIos } from '@mui/icons-material';
import { getIncomeByLevelData } from '../../../requests/api/dashboard';
import { DEFAULT_API_ERROR_MESSAGE } from '../../../utils/errors';
import { useYear } from '../../../hooks/useYear';
import Page from '../../../components/Layout/Page';
import IndicatorsTable from '../components/table';
import { IncomeByLevelData } from '../types';
import useStyles from './styles';

const IncomeByLevel: React.FC = () => {
  const classes = useStyles();
  const { selectedYear } = useYear();
  const { enqueueSnackbar } = useSnackbar();
  const history = useHistory();
  const [
    incomeByLevelData, setIncomeByLevelData,
  ] = useState<IncomeByLevelData>([{
    id: 'totals',
    label: '',
    values: {
      ivMedio: { amount: 0, variation: 0 },
      egresado: { amount: 0, variation: 0 },
      egresadoInt: { amount: 0, variation: 0 },
      bianualI: { amount: 0, variation: 0 },
      bianualII: { amount: 0, variation: 0 },
      discounts: { amount: 0, variation: 0 },
      total: { amount: 0, variation: 0 },
    },
  }, {
    id: 'lad',
    label: 'LAD',
    values: {
      ivMedio: { amount: 0, variation: 0 },
      egresado: { amount: 0, variation: 0 },
      egresadoInt: { amount: 0, variation: 0 },
      bianualI: { amount: 0, variation: 0 },
      bianualII: { amount: 0, variation: 0 },
      discounts: { amount: 0, variation: 0 },
      total: { amount: 0, variation: 0 },
    },
  }, {
    id: 'lod',
    label: 'LOD',
    values: {
      ivMedio: { amount: 0, variation: 0 },
      egresado: { amount: 0, variation: 0 },
      egresadoInt: { amount: 0, variation: 0 },
      bianualI: { amount: 0, variation: 0 },
      bianualII: { amount: 0, variation: 0 },
      discounts: { amount: 0, variation: 0 },
      total: { amount: 0, variation: 0 },
    },
  },
  {
    id: 'em',
    label: 'EM',
    values: {
      ivMedio: { amount: 0, variation: 0 },
      egresado: { amount: 0, variation: 0 },
      egresadoInt: { amount: 0, variation: 0 },
      bianualI: { amount: 0, variation: 0 },
      bianualII: { amount: 0, variation: 0 },
      discounts: { amount: 0, variation: 0 },
      total: { amount: 0, variation: 0 },
    },
  },
  {
    id: 'eme',
    label: 'EM - E',
    values: {
      ivMedio: { amount: 0, variation: 0 },
      egresado: { amount: 0, variation: 0 },
      egresadoInt: { amount: 0, variation: 0 },
      bianualI: { amount: 0, variation: 0 },
      bianualII: { amount: 0, variation: 0 },
      discounts: { amount: 0, variation: 0 },
      total: { amount: 0, variation: 0 },
    },
  }]);

  useEffect(() => {
    const fetchIncomeByLevelData = async () => {
      try {
        const response = await getIncomeByLevelData(selectedYear);
        setIncomeByLevelData(response.incomeByLevelData);
      } catch (err) {
        const e = err as AxiosError;
        enqueueSnackbar(e.response?.data.message || DEFAULT_API_ERROR_MESSAGE, {
          variant: 'error',
        });
      }
    };

    fetchIncomeByLevelData();
  }, [selectedYear]);

  const handleGoBack = () => {
    history.push('/dashboard/financiero');
  };

  return (
    <Page title="Ingresos por nivel">
      <Box>
        <Box className={classes.backButtonContainer}>
          <IconButton
            onClick={handleGoBack}
            className={classes.backButton}
            size="small"
          >
            <ArrowBackIos className={classes.backIcon} />
          </IconButton>
          <Typography className={classes.pageTitle}>
            Ingresos por nivel
          </Typography>
        </Box>

        <Box className={classes.enrollmentsContainer}>
          <IndicatorsTable
            columns={[{
              id: 'ivMedio',
              label: 'IV Medio',
            }, {
              id: 'egresado',
              label: 'Egresado',
            }, {
              id: 'egresadoInt',
              label: 'Egresado (Int.)',
            }, {
              id: 'bianualI',
              label: 'Bianual I',
            }, {
              id: 'bianualII',
              label: 'Bianual II',
            }, {
              id: 'discounts',
              label: 'Descuentos',
            }, {
              id: 'total',
              label: 'Totales',
            }]}
            rows={incomeByLevelData}
          />
        </Box>
      </Box>
    </Page>
  );
};

export default IncomeByLevel;
